module.exports = __webpack_public_path__ + "img/user-active.8f8269f8.svg";